import React, { Component } from "react";
import styled from "styled-components";
import { SubscriptionContext } from "../SubscriptionContext";
import {
    BusinessPortalHeader,
    PAYMENT_FLOW_MAX_WIDTH,
    PortalActionBar,
    PortalCaption,
    PortalIconActionButton,
    PortalMetricCard,
    PortalMetricLabel,
    PortalPanelHeader,
    PortalSectionTitle,
    PortalSurface,
} from "src/components";
import { AUSTRALIA } from "src/constants/subscriptions";

import { Forms } from "../Subscription";

import GreenCheck from "src/img/new/green-check.svg";
import MailIcon from "src/img/new/mail.svg";

const CheckIcon = styled.img`
    width: 2.5625rem;
    height: 2.5625rem;
`;

const SuccessCard = styled(PortalSurface)`
    width: 100%;
    max-width: 42.125rem;
    min-height: 43.625rem;
    margin-top: 1.125rem;
    padding: 2rem;

    @media (max-width: 640px) {
        min-height: auto;
        padding: 1rem;
    }
`;

const SuccessTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
`;

const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem;
    margin-bottom: 1.25rem;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`;

const DetailCard = styled(PortalMetricCard)`
    min-height: auto;
    align-content: start;
    gap: 0.4rem;
`;

const ReceiptCard = styled(PortalMetricCard)`
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    align-content: center;
    min-height: auto;
    margin-bottom: 1.5rem;
`;

const MailImage = styled.img`
    width: 1.9375rem;
    height: 1.375rem;
    object-fit: contain;
`;

class Success extends Component {
    static contextType = SubscriptionContext;

    render() {
        const { companyName, abn, country, totalNumber, currentForm, nextClick, isCustomizeComplete, currentSubscription } = this.context;

        return (
            <React.Fragment>
                <BusinessPortalHeader
                    title={currentForm === Forms.SUCCESS ? "Purchase Complete!" : "You Have Purchased More User Licenses!"}
                    description={currentForm === Forms.SUCCESS ?
                        "Congratulations! Your business subscription has been successfully activated, and you now have full access to all our features and services."
                        : "Congratulations! You have additional user licenses to invite users to your Me Business app! These new licenses have been created as a new subscription which can be managed in your Account Settings."
                    }
                    maxWidth={PAYMENT_FLOW_MAX_WIDTH}
                />
                <SuccessCard>
                    <PortalPanelHeader withDivider>
                        <SuccessTitle>
                            <CheckIcon src={GreenCheck} />
                            <PortalSectionTitle size="1.25rem">Subscription Purchase Successful!</PortalSectionTitle>
                        </SuccessTitle>
                    </PortalPanelHeader>

                    <DetailGrid>
                        <DetailCard>
                            <PortalMetricLabel>Business Name</PortalMetricLabel>
                            <PortalSectionTitle size="1rem">{ companyName }</PortalSectionTitle>
                        </DetailCard>

                        { country === AUSTRALIA &&
                            <DetailCard>
                                <PortalMetricLabel>ABN</PortalMetricLabel>
                                <PortalSectionTitle size="1rem">{abn}</PortalSectionTitle>
                            </DetailCard>
                        }

                        { currentForm === Forms.SUCCESS &&
                            <DetailCard>
                                <PortalMetricLabel>Country</PortalMetricLabel>
                                <PortalSectionTitle size="1rem">{ country }</PortalSectionTitle>
                            </DetailCard>
                        }

                        <DetailCard>
                            <PortalMetricLabel>User Licenses</PortalMetricLabel>
                            <PortalSectionTitle size="1rem">{ totalNumber }</PortalSectionTitle>
                        </DetailCard>

                        <DetailCard>
                            <PortalMetricLabel>Subscription Type</PortalMetricLabel>
                            <PortalSectionTitle size="1rem">{ currentSubscription.name }</PortalSectionTitle>
                            <PortalCaption margin="0">{ currentSubscription.frequencyName }</PortalCaption>
                        </DetailCard>
                    </DetailGrid>

                    <ReceiptCard>
                        <MailImage src={MailIcon} />
                        <PortalCaption margin="0" maxWidth="26.9375rem">
                            We sent a copy of your purchase receipt to your email inbox. Please check your email to access your receipt and keep it handy for your records.
                        </PortalCaption>
                    </ReceiptCard>

                    { currentForm === Forms.SUCCESS &&
                        <React.Fragment>
                            <PortalSectionTitle size="1rem">
                                { isCustomizeComplete
                                    ? "Check Your Subscriptions"
                                    : "Start Customising Your App!"
                                }
                            </PortalSectionTitle>
                        </React.Fragment>
                    }

                    <PortalActionBar
                        justifyContent="flex-start"
                        padding="1.5rem 0 0"
                        border="transparent"
                        shadow="none"
                        radius="0"
                    >
                        <PortalIconActionButton
                            type="button"
                            width="11.5625rem"
                            onClick={nextClick}
                        >
                            { currentForm === Forms.SUCCESS ? "Go to My Me App" : "Go to Account Settings" }
                        </PortalIconActionButton>
                    </PortalActionBar>
                </SuccessCard>
            </React.Fragment>
        );
    }
}

export default Success;
